import { getTenantConfig } from 'src/config/tenant'
import { getOverrideApiUrl } from 'src/new-components/forms/app-config/state'

const { protocol } = window.location

// Priority: manual override (localStorage) > tenant config > env default.
const apiUrlOverride = getOverrideApiUrl()
const tenantApiUrl = getTenantConfig().apiUrl

// When REACT_APP_USE_PROXY is on (local dev), the app talks to the
// backend SAME-ORIGIN and the dev server proxies /graph-api etc. to
// it. This removes the cross-port browser call that some local
// setups (proxies, VPNs, port blocks) drop — the API is reached on
// whatever port the app itself was loaded from.
export const baseUrl =
  process.env.REACT_APP_USE_PROXY === 'true'
    ? ''
    : `${process.env.REACT_APP_API_SSL === 'true' ? 'https:' : protocol}//${
        apiUrlOverride || tenantApiUrl || process.env.REACT_APP_API_URL
      }`

export const APIURLS = {
  production: process.env.REACT_APP_API_PRODUCTION_URL || 'not-set',
  staging: process.env.REACT_APP_API_STAGING_URL || 'not-set',
  development: process.env.REACT_APP_API_DEVELOPMENT_URL || 'not-set',
  preview: process.env.REACT_APP_API_PREVIEW_URL || 'not-set',
}
